import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TextInput, PasswordInput, Button, Paper, Title, Container } from '@mantine/core';
export function LoginPage() {
  const navigate = useNavigate();
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    navigate('/qrcode');
  };
  return <div className="min-h-screen flex items-center justify-center bg-light p-4" data-id="element-499">
      <Container size={420} className="w-full" data-id="element-500">
        <Paper radius="lg" px="xl" py="xl" withBorder shadow="md" data-id="element-501">
          <div className="text-center mb-6" data-id="element-502">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rASzWmqwcDDuZDhxwztpuY/pasted-image.svg" alt="Logo" className="h-12 mx-auto mb-3" data-id="element-503" />
            <Title order={1} className="text-primary text-2xl font-bold" data-id="element-504">
              ConecZapp
            </Title>
          </div>
          <form onSubmit={handleLogin} className="mt-6" data-id="element-505">
            <Title order={3} className="mb-6 text-center" data-id="element-506">
              Acesse sua conta
            </Title>
            <TextInput label="Email" placeholder="seu@email.com" className="mb-4" radius="lg" size="md" styles={{
            input: {
              height: '48px'
            }
          }} data-id="element-507" />
            <PasswordInput label="Senha" placeholder="Sua senha" className="mb-6" radius="lg" size="md" styles={{
            input: {
              height: '48px'
            }
          }} data-id="element-508" />
            <Button fullWidth type="submit" radius="lg" styles={{
            root: {
              backgroundColor: '#0047AB',
              height: '48px',
              '&:hover': {
                backgroundColor: '#003d91'
              }
            }
          }} data-id="element-509">
              Entrar
            </Button>
          </form>
        </Paper>
      </Container>
    </div>;
}